import React, { useEffect } from 'react';

import { useAppSelector, useAppDispatch } from 'application/providers/StoreProvider';
import { selectUserData, selectIsAppLoading, bootApp } from 'application/store';

import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

import { useApolloTypedClient } from '../StoreProvider/useApolloTypedClient';
import { useFeatureFlagsSync } from './useFeatureFlagsSync';

const AppInitializer: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const client = useApolloTypedClient();

  const userData = useAppSelector(selectUserData);
  const isLoading = useAppSelector(selectIsAppLoading);

  useEffect(() => {
    dispatch(bootApp());
  }, []);

  useFeatureFlagsSync(client, userData);

  const isWebPlayer = window.location.pathname.startsWith('/web-player');

  if (isLoading && !isWebPlayer) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};

export default AppInitializer;
